/** 兼容旧版「直接返回数组」与新版 PageResult `{ list, total }` */
export interface CapacityPageResult<T> {
  list: T[]
  total: number
}

export function asCapacityPage<T>(
  raw: unknown,
  pageNo?: number,
  pageSize?: number
): CapacityPageResult<T> {
  // 旧后端：data 直接是数组 → 前端切片分页，避免 r.list 读不到变成空表
  if (Array.isArray(raw)) {
    const all = raw as T[]
    const pn = pageNo == null || pageNo < 1 ? 1 : pageNo
    const ps = pageSize == null || pageSize < 1 ? all.length || 10 : pageSize
    const from = (pn - 1) * ps
    return { list: all.slice(from, from + ps), total: all.length }
  }
  if (raw && typeof raw === 'object') {
    const o = raw as Record<string, unknown>
    const list = Array.isArray(o.list) ? (o.list as T[]) : []
    const total = typeof o.total === 'number' ? o.total : Number(o.total) || list.length
    return { list, total }
  }
  return { list: [], total: 0 }
}
